/**
 * @generated SignedSource<<fb5f83095ec57eb5a75863b9a2ca05ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FinishUploadFileInput = {
  key: string;
};
export type TextAreaDragNDropUploadZoneFinishMutation$variables = {
  input: FinishUploadFileInput;
};
export type TextAreaDragNDropUploadZoneFinishMutation$data = {
  readonly finishUploadFile: {
    readonly downloadUrl: any;
  };
};
export type TextAreaDragNDropUploadZoneFinishMutation = {
  response: TextAreaDragNDropUploadZoneFinishMutation$data;
  variables: TextAreaDragNDropUploadZoneFinishMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FinishUploadFile",
    "kind": "LinkedField",
    "name": "finishUploadFile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TextAreaDragNDropUploadZoneFinishMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TextAreaDragNDropUploadZoneFinishMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7e0eb9bbe196bb2a78c1d45cade5ff27",
    "id": null,
    "metadata": {},
    "name": "TextAreaDragNDropUploadZoneFinishMutation",
    "operationKind": "mutation",
    "text": "mutation TextAreaDragNDropUploadZoneFinishMutation(\n  $input: FinishUploadFileInput!\n) {\n  finishUploadFile(input: $input) {\n    downloadUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "27309b49c617a5fcb62e580b16b110d1";

export default node;
